import { EntityState } from '@reduxjs/toolkit'
import { normalizeFilters } from '@user/components/Filters'
import { Draft } from 'immer'
import {
  ILead,
  LeadPageState,
  sortOptionArray,
  defaultOrderBy,
  LeadFilterSet,
} from '.'

export const setOrderBy = (
  state: Draft<EntityState<ILead> & LeadPageState>,
  orderBy: string,
) => {
  if (state.mode === 'card' && !sortOptionArray.includes(orderBy))
    state.filterSet.orderBy = defaultOrderBy
}

export const updateFilterState = (
  state: Draft<EntityState<ILead> & LeadPageState>,
  filterSet: LeadFilterSet,
) => {
  state.page = 1
  state.shouldFetchList = true
  state.filterSet = normalizeFilters<ILead, LeadFilterSet>(filterSet)
  setOrderBy(state, filterSet.orderBy)
}
